module.exports = __webpack_public_path__ + "img/vasty-behance.16867b25.jpg";